module.exports = __webpack_public_path__ + "static/media/13.4fbd1f24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/13.jpg
// module id = 274
// module chunks = 0